module.exports = __webpack_public_path__ + "static/media/circo2024_aros.a4e2bab8.webp";